import React, { useEffect, useState } from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-hot-toast';
import { useFormikContext } from 'formik';
import Text from 'components/Text';
import { IconButton } from 'components/Button';
import TextareaField from "forms/fields/TextareaField";
import AcceptConditionsField from "forms/fields/UserAgreementCheckboxField";
import UserFields from 'forms/forms/CheckoutForm/UserFields';
import DeliveryFields from 'forms/forms/CheckoutForm/DeliveryFields';
import PaymentField from 'forms/fields/PaymentField';
import PaymentBalanceField from 'forms/fields/PaymentBalanceField';
import Summary from 'forms/forms/CheckoutForm/Summary';
import { useMobile } from 'utils/media';
import CDEKWidgetContainer from 'forms/forms/CheckoutForm/CDEKWidgetContainer';
import KZNotEnoughBalance from 'components/KZNotEnoughBalance';
import Model from '../../../../model';
import './index.sass'

const { block, el } = bem('checkout-form');

export function loadCDEKscript() {
    return new Promise(function(resolve, reject){
        if (typeof window !== "undefined") {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/@cdek-it/widget@3';
            script.addEventListener('load', function () {
                resolve();
            });
            script.addEventListener('error', function (e) {
                reject(e);
            });
            document.body.appendChild(script);
        }
    })
};

const Form = ({ price, cartItems, form }) => {

    const [ deliveryPrice, setDeliveryPrice ] = useState(0)
    const [ items, setItems ] = useState([]);
    const [ country, setCountry ] = useState('RU');
    const [ showWidget, setShowWidget ] = useState(false);
    const [ cdekLoadStatus, setCdekLoadStatus ] = useState('pending');
    const { isMobile } = useMobile();

    const { user, isAuthenticated, customerName, customerInfo, username } = Model.user;
    const { setFieldValue } = useFormikContext();

    const { kzNotEnoughBalance, isKZ } = Model.kz;

    useEffect(() => {
        loadCDEKscript()
            .then(() => {
                setCdekLoadStatus('loaded');
                console.log('cdek script loaded')})
            .catch(() => {
                toast.error('error loading cdek script');
                setCdekLoadStatus('failed');
            })
    }, []);

    useEffect(() => {
        if (isAuthenticated && username) {
            setFieldValue('customerPhone', username);
        }
    }, [ isAuthenticated, username ]);

    const values = form.values;

    const prepareItems = (cartItems) => {
        const result = [];
        cartItems.forEach(item => {
            const { cartAmount, length, height, width, weight, price } = item.data;
            result.push(...new Array(cartAmount).fill({
                length,
                height,
                width,
                weight,
                price
            }))
        })
        return result;
    }

    useEffect(() => {
        if (cartItems.length === 0) {
            console.error('no items in cart');
            toast.error( 'В корзине нет товаров');
        } else {
            setItems(() => prepareItems(cartItems));
        }
    }, [ cartItems ])

    return <form onSubmit={ form.handleSubmit }>
        <div className={ el('title') }>
            <Text serif>Оформление заказа</Text>
        </div>
        <div className={ el('user-fields') }>
            <UserFields customerName={ customerName } customerInfo={ customerInfo } />
            <TextareaField
                name='comment'
                placeholder={ 'Комментарий к заказу' }
            />
            <AcceptConditionsField name='acceptConditions' />
        </div>
        <div className={ el('middle-block') }>
            <div className={ el('delivery-block') }>
                <DeliveryFields
                    form={ form }
                    setDeliveryPrice={ setDeliveryPrice }
                    items={ items }
                    cdekLoadStatus={ cdekLoadStatus }
                    showWidget={ showWidget }
                    setShowWidget={ setShowWidget }
                />
                { isMobile && <CDEKWidgetContainer showWidget={showWidget} address={values.address} cdekLoadStatus={cdekLoadStatus}/>}
            </div>
            { !isKZ && <div className={ el('payment-block') }>
                <div className={el('payment-block-title')}>
                    <Text serif>Способы оплаты</Text>
                </div>
                <PaymentField name='paymentSystem' />
            </div> }
        </div>
        { !isMobile && <CDEKWidgetContainer showWidget={showWidget} address={values.address} cdekLoadStatus={cdekLoadStatus} /> }
        <div className={ el('bottom-block') }>
            <div className={ el('balance-block') }>
                <div className={ el('balance-block-title') }>
                    <Text serif>Оплата баллами</Text>
                </div>
                <PaymentBalanceField className={ el('balance') }
                                     username={ user?.username }
                                     balance={ user?.balance }
                                     price={ +deliveryPrice + +price }
                                     country={ country }
                />
            </div>
            <div className={ el('summary-block') }>
                <Summary deliveryPrice={ deliveryPrice }
                         saleSum={ values.saleSum }
                         price={ price }
                />
            </div>
        </div>
        <KZNotEnoughBalance price={price}/>
        <div className={ el('buttons') }>
            <IconButton
                name={ 'shopping-cart' }
                Tag='button'
                type='submit'
                mod={ 'gold' }
                disabled={ form.isSubmitting || kzNotEnoughBalance(price) }>
                Перейти к оплате
            </IconButton>
        </div>
    </form>
}

export default observer(Form);
